import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface SelfPacedUserRow {
  user_id: string;
  full_name: string | null;
  email: string | null;
  program_id: string;
  program_name: string;
  plan_start_at: string | null;
  total_mandatory: number;
  done_mandatory: number;
  progress_pct: number;
  overdue_chapters: number;
  last_activity: string | null;
}

export interface SelfPacedRouteRow {
  program_id: string;
  program_name: string;
  enrolled: number;
  avg_progress: number;
  completed: number;
}

export interface SelfPacedInterestRow {
  id: string;
  full_name: string | null;
  email: string;
  program_id: string;
  program_name: string | null;
  created_at: string;
}

export interface EnterpriseSelfPacedData {
  users: SelfPacedUserRow[];
  routes: SelfPacedRouteRow[];
  interests: SelfPacedInterestRow[];
}

const EMPTY: EnterpriseSelfPacedData = { users: [], routes: [], interests: [] };

/** Métricas de rutas de autoaprendizaje para el panel empresarial (agregadas server-side). */
export function useEnterpriseSelfPaced(organizationId: string | undefined) {
  const enabled = !!organizationId && organizationId !== 'all';

  return useQuery({
    queryKey: ['enterprise-self-paced', organizationId],
    queryFn: async (): Promise<EnterpriseSelfPacedData> => {
      const { data, error } = await supabase.rpc('get_enterprise_self_paced_metrics' as any, {
        _org_id: organizationId,
      });
      if (error) throw error;
      const payload = (data ?? {}) as Partial<EnterpriseSelfPacedData>;
      return {
        users: payload.users ?? [],
        routes: payload.routes ?? [],
        interests: payload.interests ?? [],
      };
    },
    enabled,
    placeholderData: EMPTY,
  });
}
